import { gql } from '@apollo/client'

const UPDATE_INGREDIENT_COMPONENT_DETAILS_MUTATION = gql`
  mutation updateIngredientComponentDetails(
    $id: ID!
    $data: IngredientComponentDetailsInput!
  ) {
    updateIngredientComponentDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      isWholeFood
      isVague

      componentIngredients {
        id
        type
      }
    }
  }
`

export default UPDATE_INGREDIENT_COMPONENT_DETAILS_MUTATION
